<div>
  <p-dialog
    #customerTaggingDialog
    header=""
    [(visible)]="showCustomerTaggingDialog"
    [responsive]="true"
    [modal]="true"
  >
    <div>
      <div class="general-container ui-g">
        <div class="ui-g-6 general-tags-container">
          <tagging-tags-details
            [organisationTags]="generalTags"
            [readOnly]="false"
            (selectorClosed)="onTagSelectorClosed($event, true)"
          >
          </tagging-tags-details>
          <div class="ui-grid-row tag-buttons">
            <button
              type="button"
              class="green-btn"
              pButton
              icon="fa ui-icon-check"
              (click)="applyGeneralTags()"
              label="Apply Tags"
            ></button>
            <button
              type="button"
              class="red-btn"
              pButton
              icon="fa ui-icon-close"
              label="Remove Tags"
              (click)="removeGeneralTags()"
            ></button>
          </div>
        </div>
        <div class="ui-g-6 exclude-suppliers-container">
          <div class="ui-grid-row centered-buttons">
            <button
              type="button"
              class="blue-btn"
              pButton
              (click)="selectSupplierExclusions()"
              label="Select Excluded Suppliers"
            ></button>
            <button
              type="button"
              class="green-btn"
              pButton
              icon="fa ui-icon-check"
              (click)="applyGeneralExclusions()"
              label="Apply Exclusions"
              [disabled]="!excludedSuppliers || excludedSuppliers.length == 0"
            ></button>
            <button
              type="button"
              class="red-btn"
              pButton
              icon="fa ui-icon-close"
              label="Remove Exclusions"
              (click)="removeGeneralExclusions()"
            ></button>
          </div>

          <!-- show list of suppliers selected from dialog -->
          <div class="exclude-suppliers-list">
            <h3>
              Selected suppliers:
              <span *ngIf="!excludedSuppliers || excludedSuppliers.length == 0">none</span>
            </h3>
            <ol>
              <li *ngFor="let excluded of excludedSuppliers">{{ excluded.name }}</li>
            </ol>
          </div>

          <div class="exclude-suppliers-reason">
            <textarea
              pInputTextarea
              [rows]="3"
              [cols]="80"
              [(ngModel)]="excludeSuppliersReason"
              [maxlength]="2048"
              class="exclude-suppliers-text"
              placeholder="Reason for exclusion"
            ></textarea>
          </div>
        </div>
      </div>

      <div class="customer-container">
        <p-treeTable [value]="orgNodes" [columns]="cols" [(selection)]="selectedItems">
          <ng-template pTemplate="caption">
            <div style="text-align: left">Customer, Departments and Teams</div>
          </ng-template>
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns">
                {{ col.header }}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
            <tr>
              <td *ngFor="let col of columns; let i = index">
                <p-treeTableToggler [rowNode]="rowNode" *ngIf="i == 0"></p-treeTableToggler>
                <p-checkbox
                  binary="true"
                  *ngIf="i == 0"
                  [disabled]="parentChecked(rowNode)"
                  [ngModel]="isRowSelected(rowNode)"
                  (click)="toggleRowSelection(rowNode)"
                >
                </p-checkbox>
                <span *ngIf="i == 0">{{ rowData[col.field] }}</span>
                <!-- only col 0 can be shown as-is, the others require code below -->

                <div
                  class="exclude-suppliers-node"
                  *ngIf="col.field == 'orderPreferences' && nodeHasOrderPreferences(rowNode)"
                >
                  <div class="exclude-suppliers-list">
                    <ol>
                      <li *ngFor="let excluded of rowData[col.field]">
                        {{ excluded.targetOrganisation.name }}
                      </li>
                    </ol>
                  </div>
                  <div class="exclude-suppliers-reason">
                    Reason: {{ rowData[col.field][0]?.reason }}
                  </div>
                  <div class="ui-g exclude-suppliers-node-buttons">
                    <button
                      pButton
                      type="button"
                      class="ui-g ui-g-6 blue-btn"
                      label="Edit"
                      style="margin: 0px; margin-right: 3px"
                      (click)="showSuppliersForOrderPreference(rowNode)"
                    ></button>
                    <button
                      pButton
                      type="button"
                      label="Delete"
                      class="ui-g ui-g-6 red-btn"
                      style="margin: 0px; margin-left: 3px"
                      icon="fa ui-icon-close"
                      (click)="deleteOrderPreferences(rowNode)"
                    ></button>
                  </div>
                </div>
                <div *ngIf="col.field == 'tags' && nodeHasTags(rowNode)">
                  <tagging-tags-details
                    [organisationTags]="rowData[col.field]"
                    [readOnly]="false"
                  ></tagging-tags-details>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="summary">
            <div style="text-align: left">
              Selected Nodes:
              <span *ngIf="!selectedItems || selectedItems.length === 0" style="font-weight: normal"
                >none</span
              >
              <ul *ngIf="selectedItems && selectedItems.length">
                <li *ngFor="let node of selectedItems">
                  <span style="font-weight: normal">{{ node.data.name }}</span>
                </li>
              </ul>
            </div>
          </ng-template>
        </p-treeTable>
      </div>
    </div>
  </p-dialog>
  <p-dialog
    header="Suppliers List"
    #supplierDialog
    [(visible)]="showSupplierDialog"
    [modal]="true"
    [style]="{ width: '900px', height: '750px' }"
    (visibleChange)="onSupplierExclusionDialogClosed()"
  >
    <div class="supplier-container">
      <tagging-select-supplier
        (selectedSuppliersChanged)="onSelectedSuppliersChanged($event)"
        [parentSelectedSuppliers]="selectedSuppliers"
      ></tagging-select-supplier>
    </div>
  </p-dialog>
</div>
